import React, { Component } from 'react';

import { Form } from 'formsy-semantic-ui-react';
import { singleLineText, durationValidation } from './RegexValidation';
import { Button } from 'semantic-ui-react';


export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            text: props.text,
            formcyButtonDisabled: false
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.props.text !== newProps.text) {
            this.setState({ name: newProps.name })
            this.setState({ text: newProps.text })
        }
    }

    addClass() {
        var element = document.getElementById(this.props.name + "_action_id");
        element.classList.add("active");
    }
    removeClass() {
        this.setState({
            name: this.props.name,
            text: this.props.text,
        })
        var element = document.getElementById(this.props.name + "_action_id");
        element.classList.remove("active");
    }

    updateValue = (e) => {
        this.setState({ text: e.target.value.trim() })
    }

    handleOnFocus = () => {
        this.addClass()
    }
    handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            this.props.onSaveClick(this.state)
            document.getElementById(this.props.name + "_input_id").blur();
        }
        if (e.keyCode === 27) {
            document.getElementById(this.props.name + "_input_id").blur();
        }
    }
    saveClick = () => {
        this.props.onSaveClick(this.state)
        this.removeClass()
    }
    cancelClick = () => {
        this.removeClass()
    }

    buttonDisabled = (e, set) => {
        this.setState({ formcyButtonDisabled: set });
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <div className="single-line-input-text">
                <Form noValidate
                    onValid={(e) => this.buttonDisabled(e, true)}
                    onInvalid={(e) => this.buttonDisabled(e, false)}
                    className="formcyForm"
                >
                    <Form.Input
                        required
                        label={this.props.name}
                        name={this.props.name}
                        id={this.props.name + "_input_id"}
                        className="editTextInput"
                        errorLabel={errorLabel}
                        icon={this.state.blankTextError ? "exclamation triangle" : ""}
                        value={this.state.text}
                        validations={{ matchRegexp: this.props.valueType === 'duration' ? durationValidation : singleLineText }}
                        validationErrors={{
                            matchRegexp: `${this.props.valueType === 'duration' ?
                                "No Characters Allowed. Activity should be in range from 0 to 999." :
                                "Max limit is 128. No space allowed in starting."} `,
                            isDefaultRequiredValue: `${this.props.name} is required`,
                        }}
                        instantValidation
                        onChange={this.updateValue}
                        onFocus={this.handleOnFocus}
                        onKeyDown={this.handleKeyPress}
                    />
                </Form>
                <div
                    className="actionBtn"
                    id={this.props.name + "_action_id"} >
                    <Button
                        type="button"
                        icon="cancel"
                        className="button-cancel pad_5"
                        onClick={this.cancelClick}
                        id={this.props.name + '_cancel'} />
                    <Button
                        type="submit"
                        icon="check"
                        className="button-submit pad_5"
                        disabled={!this.state.formcyButtonDisabled}
                        onClick={this.saveClick}
                        id={this.props.name + '_check'} />
                </div>
            </div>

        );
    }
}
